import OrderingSummaryButtonSFC from "./OrderingSummaryButton.vue";
export const OrderingSummaryButton = OrderingSummaryButtonSFC;
